import { Injectable } from "@snap/ts-inject";
import { lensCoreFactory } from "../lens-core-module/loader/lensCoreFactory";
import type { LensCore } from "../lens-core-module/lensCore";
import { getLogger } from "../logger/logger";
import type { GeoDataProvider } from "./geoDataProvider";
import { isGeoData } from "./geoDataProvider";
import { geoDataProviderFactory } from "./geoDataProvider";

const logger = getLogger("registerGeoDataProvider");

/**
 * @internal
 */
export const registerGeoDataProvider = Injectable(
    "registerGeoDataProvider",
    [lensCoreFactory.token, geoDataProviderFactory.token],
    (lensCore: LensCore, getGeoData: GeoDataProvider) => {
        if (!lensCore.setGeoDataProvider) {
            // NOTE: setGeoDataProvider was added in LensCore@297. This check ensures compatibility with older versions.
            logger.warn("setGeoDataProvider is not defined.");
            return;
        }

        lensCore.setGeoDataProvider(() => {
            const geoData = getGeoData();
            // We allow geo data providers to return undefined
            // in this case we do nothing
            if (geoData) {
                if (!isGeoData(geoData)) {
                    throw new Error("Expected GeoData object.");
                }
                lensCore.provideGeoData({ geoData });
            }
        });
    }
);
